import React from 'react';
import { Link } from 'react-router-dom';
import { GithubIcon, TwitterIcon, InstagramIcon, LinkedinIcon } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="w-full bg-gray-50 border-t border-gray-200" data-id="element-24">
      <div className="container mx-auto px-4 py-12" data-id="element-25">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-26">
          <div className="mb-6 md:mb-0" data-id="element-27">
            <Link to="/" className="flex items-center" data-id="element-28">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/c6xsg6Mo625scKjodLycdg/AznShawnAlahah_signature_transparent.png" alt="Azn Shawn Alahah" className="h-8 w-auto" data-id="element-29" />
            </Link>
            <p className="mt-2 text-sm text-gray-600" data-id="element-30">
              Personal website & portfolio
            </p>
          </div>
          <div className="flex space-x-6" data-id="element-31">
            <a href="#" className="text-gray-500 hover:text-gray-800" aria-label="Twitter" data-id="element-32">
              <TwitterIcon className="h-5 w-5" data-id="element-33" />
            </a>
            <a href="#" className="text-gray-500 hover:text-gray-800" aria-label="Instagram" data-id="element-34">
              <InstagramIcon className="h-5 w-5" data-id="element-35" />
            </a>
            <a href="#" className="text-gray-500 hover:text-gray-800" aria-label="LinkedIn" data-id="element-36">
              <LinkedinIcon className="h-5 w-5" data-id="element-37" />
            </a>
            <a href="#" className="text-gray-500 hover:text-gray-800" aria-label="GitHub" data-id="element-38">
              <GithubIcon className="h-5 w-5" data-id="element-39" />
            </a>
          </div>
        </div>
        <div className="mt-8 border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-40">
          <p className="text-sm text-gray-600" data-id="element-41">
            © {currentYear} Azn Shawn Alahah. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0 flex space-x-6" data-id="element-42">
            <Link to="/about" className="text-sm text-gray-600 hover:text-gray-800" data-id="element-43">
              About
            </Link>
            <Link to="/contact" className="text-sm text-gray-600 hover:text-gray-800" data-id="element-44">
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}